import React, { useState } from "react";
import FormularioRD from "../rdstation/formularioRD";
import { useModal } from "../contexts/ModalContext";

export default function SquadDiferenciais({
    leftColumnContent,
    rightColumnItems,
}) {
    const [activeItem, setActiveItem] = useState(0);
    const { openModal } = useModal();

    return (
        <div className="w-full bg-[#040116] py-24 relative overflow-hidden">
            {/* Background com grafismos */}
            <div className="absolute inset-0 opacity-10 flex justify-end">
                <img
                    src="/assets/grafismos2.png"
                    alt="Grafismos"
                    className="h-full object-contain object-right-top"
                />
            </div>

            <div className="max-w-[1200px] mx-auto relative z-10 flex flex-col lg:flex-row">
                {/* Coluna da esquerda - 1/3 - Fixed position */}
                <div className="lg:w-1/3 lg:pr-8">
                    <div className="lg:sticky">
                        <div className="text-white flex items-center justify-center h-full px-4">
                            {leftColumnContent.title}
                        </div>

                        {/* Box com modelos alternativos */}
                        <div className="bg-[#2A0D5D] rounded-lg py-8 mt-8 max-w-[260px] ml-4">
                            <h3 className="text-white text-xl font-inter-bold mb-8 px-12">
                                {leftColumnContent.subtitle}
                            </h3>
                            <ul className="text-white mb-8 px-12">
                                {leftColumnContent.items.map((item, index) => (
                                    <li
                                        key={index}
                                        className="mb-2 flex items-center"
                                    >
                                        <a
                                            href={item.link}
                                            className="text-white hover:border-b hover:border-[#A002CB] flex items-center group"
                                        >
                                            {item.text}{" "}
                                            <span className="text-white ml-2 opacity-0 group-hover:opacity-100 rotate-45">
                                                ↑
                                            </span>
                                        </a>
                                    </li>
                                ))}
                            </ul>
                            <button
                                onClick={() => openModal(<FormularioRD />)}
                                className="h-[48px] w-[206px] mx-auto flex items-center justify-center bg-gradient-to-r from-[#4B3BDB] to-[#A002CB] text-white font-medium py-3 rounded-full transition-all duration-300 hover:scale-105 cursor-pointer"
                            >
                                {leftColumnContent.buttonText}
                            </button>
                        </div>
                    </div>
                </div>

                {/* Coluna da direita - 2/3 */}
                <div className="lg:w-2/3 px-16 lg:ml-auto">
                    {rightColumnItems.map((item, index) => (
                        <div
                            key={index}
                            className="border-t border-[#A800E4] py-6"
                            onClick={() => setActiveItem(index)}
                        >
                            <div className="flex items-center justify-between cursor-pointer">
                                <div className="flex items-center gap-4">
                                    <span className="text-white text-inter-regular text-xl">
                                        {item.id}
                                    </span>
                                    <h3 className="text-white font-inter-bold text-xl tracking-wider">
                                        {item.title}
                                    </h3>
                                </div>
                                <button
                                    className={`w-8 h-8 rounded-full flex items-center justify-center transition-colors ${
                                        activeItem === index
                                            ? "bg-[#A800E4]"
                                            : ""
                                    }`}
                                >
                                    {activeItem === index ? (
                                        <svg
                                            width="10"
                                            height="10"
                                            viewBox="0 0 14 8"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M7 0L13.9282 7.5H0.0717969L7 0Z"
                                                fill="white"
                                            />
                                        </svg>
                                    ) : (
                                        <svg
                                            width="10"
                                            height="10"
                                            viewBox="0 0 14 8"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="rotate-180"
                                        >
                                            <path
                                                d="M7 0L13.9282 7.5H0.0717969L7 0Z"
                                                fill="white"
                                            />
                                        </svg>
                                    )}
                                </button>
                            </div>
                            <div
                                className={`overflow-hidden transition-all duration-500 ease-in-out ${
                                    activeItem === index
                                        ? "max-h-[200px] opacity-100"
                                        : "max-h-0 opacity-0"
                                }`}
                            >
                                <div className="mt-4 pl-10 text-white pr-8 font-inter-regular">
                                    {item.description}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
